export const insurers = [
  'Advanced Insurance Consultants Ltd',
  'Aro Insurance',
  'Aviva',
  'Alan Boswell Group',
  'AIG',
  'Aon',
  'Alice Castle Ltd',
  'Allianz Global',
  'AXA',
  'Beazley',
  'Berkley',
  'Chiswell Insurance',
  'Churchill Insurance',
  'Chubb European',
  'CNA Hardy',
  'Direct Line',
  'Finsbury Insurance',
  'Covea Insurance',
  'Ecclesiastical',
  'Equipsme Health Insurance',
  'HDI',
  'Howden Group',
  'Hiscox',
  'Liberty Mutual',
  'Kingsbridge',
  'Lloyds Banking Group',
  'Maltings Insurance',
  'Manchester Underwriting',
  'Markel Direct',
  'Martinez & Partners Ltd',
  'Meadow Broking Limited',
  'Marsh',
  'MGB Insurance Brokers',
  'McParland Finn Ltd',
  'Munich RE',
  'Modus Insurance',
  'New Dawn Risk Group',
  'NBS',
  'NIG Insurance',
  'Onyx Insurance Brokers Limited',
  'Northern Alliance Brokers Limited',
  'Paul Evans ACII Chartered Insurance Broker',
  'Pen Underwriting Insurance',
  'Perkins Slade Ltd',
  'Royal and Sun Alliance',
  'Protector',
  'QBE',
  'Sompo International',
  'Tokio Marine HCC',
  'Zurich',
  'Travelers Insurance',
  'UMAL',
  'Other'
]; 